import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'semantic-ui-react';

import PaginationMenu from './PaginationMenu';

const ListViewTable = (props) => {
  const { columns, rows, rowKey, currentPage, totalPages } = props;
  return (
    <Table>
      <Table.Header>
        <Table.Row>
          {columns.map(c => (
            <Table.HeaderCell key={c.key} collapsing={c.collapsing}>{c.label}</Table.HeaderCell>
          ))}
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {rows.map(r => (
          <Table.Row key={r[rowKey]}>
            {columns.map(c => (
              <Table.Cell key={c.key} collapsing={c.collapsing}>{r[c.key]}</Table.Cell>
            ))}
          </Table.Row>
        ))}
      </Table.Body>

      {currentPage && totalPages > 1 && (
        <Table.Footer>
          <Table.Row>
            <Table.HeaderCell colSpan={`${columns.length}`}>
              <PaginationMenu floated="right" pages={totalPages} />
            </Table.HeaderCell>
          </Table.Row>
        </Table.Footer>
      )}
    </Table>
  );
};

export default ListViewTable;

ListViewTable.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.exact({
    label: PropTypes.string,
    key: PropTypes.string.isRequired,
    collapsing: PropTypes.bool,
  })).isRequired,
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
  rowKey: PropTypes.string.isRequired,
  currentPage: PropTypes.number,
  totalPages: PropTypes.number,
};
